import React from "react";

import classnames from "classnames";

function LogobarWrapper({ children, isActive = false, handleClick }) {
    return (
        <li className={classnames("fl logobar", { activity: isActive })} onClick={handleClick}>
            {children}
        </li>
    );
}

export default LogobarWrapper;
